export default function Heatmap() {
  return (
    <div className="bg-white p-6 rounded-xl shadow">
      Heatmap
    </div>
  );
}
